import { MainColor } from '../../../palette/colors';

export const getInternalListItem = () => {
  return {
    defaultState: {
      symbolColor: 'coolGrey60' as MainColor,
      actionSVGColor: 'navy80' as MainColor,
      color: 'navy95' as MainColor,
      afterExpandColor: 'navy80' as MainColor,
    },
    hover: {
      backgroundColor: 'navy10' as MainColor,
    },
    selected: {
      backgroundColor: 'navy10' as MainColor,
    },
  };
};

export type InternalListItemTheme = ReturnType<typeof getInternalListItem>;
